import React from "react";
import { TextField, FormControl, Select, MenuItem, Box } from "@mui/material";

const RATING_OPTIONS = ["отл", "хор", "удовл", "неуд", "плох"];

const TextFieldWithSelector = ({ label, textValue, selectorValue, onTextChange, onSelectorChange, disabled = false, minRows = 3, backgroundColor, options = RATING_OPTIONS }) => {
  return (
    <Box sx={{ marginBottom: "20px" }}>
      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px"
      }}>
        <Box sx={{
          fontSize: "14px",
          fontWeight: 600,
          color: "#1A1E24"
        }}>
          {label}
        </Box>
        <FormControl size="small" sx={{ minWidth: "120px" }} disabled={disabled}>
          <Select
            value={selectorValue || ""}
            onChange={(e) => onSelectorChange(e.target.value)}
            displayEmpty
            sx={{
              fontSize: "14px",
              "& fieldset": {
                borderColor: "#e0e0e0",
              },
              "&:hover fieldset": {
                borderColor: "#1976d2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976d2",
              },
            }}
          >
            <MenuItem value="">
              <em>-</em>
            </MenuItem>
            {options.map((option, index) => (
              <MenuItem key={index} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <TextField
        value={textValue || ""}
        onChange={(e) => onTextChange(e.target.value)}
        disabled={disabled}
        multiline
        minRows={minRows}
        fullWidth
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            fontSize: "14px",
            backgroundColor: backgroundColor || "transparent",
            "& fieldset": {
              borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#1976d2",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#1976d2",
            },
          },
        }}
      />
    </Box>
  );
};

export default TextFieldWithSelector;
